// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__3aqAT","footer":"ChangeClinic_footer__30myC"};